import { useContext, useState } from "react";
import UiContext from "../../../../store/ui-context";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";

export const useAPIEditKendaraanService = (props) => {
  const { onConfirmed } = props;

  const uiContext = useContext(UiContext);
  const { requestGet, requestGetOne, requestPost, loading } = useAPIRequest();

  const [data, setData] = useState({});
  const [error, setError] = useState({});

  const [listService, setListService] = useState([]);

  //  API call section

  const fetchData = async ({ id, extraData }) => {
    return requestGetOne({
      fullUrl: `/api/masterdata/kendaraan/one/${id}`,
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        const newData = reformatDataAfterFetch(_data);
        if (extraData) {
          setData({ ...extraData, ...newData });
          fetchListService(_data.data_services);
        } else {
          setData(newData);
        }
      },
    });
  };

  const fetchListService = async (selecteds) => {
    return requestGet({
      fullUrl: `/api/masterdata/service/data`,
      params: {
        page: 1,
        take: 1000,
        filter: "",
        order: "nama",
        order_method: "ASC",
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ pagination, message, data }) => {
        const newData = data.map((el) => {
          return {
            ...el,
            selected: selecteds.find((item) => item.id === el.id)
              ? true
              : false,
          };
        });
        setListService(newData);
      },
    });
  };

  const saveData = async () => {
    setError({});

    return requestPost({
      fullUrl: `/api/masterdata/kendaraan/save`,
      body: reformatDataBeforeSave(data),
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        uiContext.showSuccessMsg("Success", message);
        const newData = reformatDataAfterFetch(_data);
        onConfirmed(newData);
      },
    });
  };

  // other function section

  const validate = () => {
    let valid = true;
    let newEror = {};

    setError(newEror);
    return valid;
  };

  const reformatDataBeforeSave = (_data) => {
    const newData = data;

    const newListSelectedService =
      listService
        .filter((el) => el.selected)
        .map((el) => {
          const res = {...el, service_id: el.id};

            if (Array.isArray(newData.data_services)) {
              newData.data_services.forEach((item) => {
                if (item.id === el.id && item.pivot) {
                  res.tanggal_terakhir_service = item.pivot.tanggal_terakhir_service;
                  res.last = item.pivot.last;
                  res.next = item.pivot.next;
                }
              });
            }

          return res;
        }) ?? [];
    newData.data_services = newListSelectedService;

    return newData;
  };

  const reformatDataAfterFetch = (_data) => {
    return _data;
  };

  const fetchDataOrCreateNew = ({ id, extraData }) => {
    setListService([]);
    if (id && id > 0) {
      fetchData({ id, extraData });
    } else {
      if (extraData) {
        setData({ ...generateNewData(), ...extraData });
      } else {
        setData(generateNewData());
      }
    }
  };

  const generateNewData = () => {
    return {
      // nama: "",
      // default_km: 0,
      // default_km_warning: 0,
    };
  };

  // handle ui event section

  const handleOnConfirm = () => {
    const valid = validate();
    if (valid) {
      saveData();
    }
  };

  return {
    loading,
    data,
    setData,
    listService,
    setListService,
    error,
    fetchDataOrCreateNew,
    handleOnConfirm,
    onConfirmed,
  };
};
